import React from 'react';
import { FaCalendarCheck } from 'react-icons/fa';

export default function PeriodicServicePath({ active = false, onToggle }) {
  return (
    <div className="rounded-xl border border-blue-100 bg-blue-50/80 px-4 py-3">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="text-sm font-semibold text-gray-900">Just service my car</p>
          <p className="mt-0.5 text-xs text-gray-600">
            Periodic packages — Medium &amp; Large partner garages only.
          </p>
        </div>
        <button
          type="button"
          onClick={() => onToggle?.(!active)}
          className={`inline-flex items-center justify-center gap-2 rounded-lg px-4 py-2 text-sm font-semibold transition ${
            active
              ? 'bg-blue-600 text-white'
              : 'border border-blue-200 bg-white text-blue-700 hover:bg-blue-100'
          }`}
        >
          <FaCalendarCheck aria-hidden />
          {active ? 'Periodic mode on' : 'Find periodic service'}
        </button>
      </div>
    </div>
  );
}
